<template>
  <button
    v-if="isMobile && cartItemCount > 0"
    class="fixed z-50 bottom-4 right-4 rounded-full shadow-lg bg-[var(--header-color)] text-white w-14 h-14 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/70"
    @click="$root.$emit('open-cart')"
    aria-label="Open cart"
    data-testid="floating-cart-button"
  >
    <span class="sr-only">Open cart</span>
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 6M7 13l-1.5 6m0 0h9M17 13v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6"></path>
    </svg>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FloatingCartButton',
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
    }
  },
  computed: {
    ...mapGetters(['cartItemCount']),
    isMobile() {
      return this.windowWidth < 768
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
/* Slight bounce to draw attention */
button { transition: transform 0.2s ease; }
button:active { transform: scale(0.96); }
</style>
